import { JetView } from 'webix-jet';
import { devConfig, countries, profile } from 'config/config';

/**
 * Class representing the Filter Sessions Report View.
 * @extends JetView
 */
export default class FilterSessionsReportView extends JetView {
    /**
     * Configures the layout of the filter sessions report view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section of the form with session filters
        const left = {
            margin: 5,
            id: 'a1',
            autoheight: true,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'SessionId',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Sesión'),
                            labelPosition: 'top',
                            placeholder: _('ID Sesión'),
                            invalidMessage: _('ID Session is required'),
                        },
                        {
                            view: 'text',
                            name: 'PlayerId',
                            type: 'number',
                            label: "<span class='icon-user'></span>" + _('ID Usuario'),
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'),
                            invalidMessage: _('ID Usuario is required'),
                        },
                        {
                            view: 'text',
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true,
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'), // Default date range
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'TypeClosed',
                            label: "<span class='icon-mail'></span>" + _('Tipo de Cierre'),
                            labelPosition: 'top',
                            placeholder: _('Tipo de Cierre'),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: 'M', value: _('Manual') },
                                { id: 'A', value: _('Automatico') },
                                { id: 'S', value: _('Sistema') },
                            ],
                        },
                        { id: 'grav2', gravity: 2 }, // Gravity for layout spacing
                    ],
                },
            ],
        };

        // Second left section of the form with additional filters
        const left2 = {
            margin: 5,
            id: 'a1',
            autoheight: true,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'Game',
                            localId: 'game:combo',
                            label: "<span class='icon-games'></span>" + _('Juego'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [],
                        },
                        {
                            view: 'text',
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true,
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'), // Default date range
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'text',
                            name: 'UserCreation',
                            label: "<span class='icon-folder-add'></span>" + _('Usuario Creación'),
                            labelPosition: 'top',
                            placeholder: _('Usuario Creación'),
                            invalidMessage: _('Usuario Creación is required'),
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'UserModified',
                            label: "<span class='icon-mode_edit'></span>" + _('Usuario Modificó'),
                            labelPosition: 'top',
                            placeholder: _('Usuario Modificó'),
                            invalidMessage: _('Usuario Modificó is required'),
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Country options
                                },
                            },
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect2',
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: profile.Settings.ReportCountry, // Default country from profile
                            readonly: true,
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Country options
                                },
                            },
                            hidden: !devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByCountry',
                            css: 'country-hide',
                        },
                        { id: 'grav2', gravity: 1 }, // Gravity for layout spacing
                    ],
                },
            ],
        };

        // Upper section of the form
        const upper_section = {
            height: document.body.offsetWidth < 500 ? 370 : 0,
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Contains the first left section
                },
            ],
        };

        // Second upper section of the form
        const upper_section2 = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 300 : 0,
            rows: [
                {
                    margin: 10,
                    cols: [left2], // Contains the second left section
                },
            ],
        };

        // Accordion section for advanced filters
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'),
                            body: {
                                padding: 10,
                                rows: [upper_section2],
                            },
                        },
                    ],
                },
            ],
        };
        /**
         * Configuration object for the buttons in the filter form.
         * Contains buttons for clearing the form and submitting the form.
         */
        const buttons = {
            margin: 10, // Margin around the component
            cols: [
                {},
                {
                    view: 'button', // Button component
                    value: _('Limpiar'), // Localized label for the button
                    autowidth: true, // Automatically adjust width
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Reset form values
                        $$('CountrySelect').setValue($$('myForm').getCleanValues().CountrySelect); // Reset country select value
                        $$('Datepicker').setValue(''); // Reset date picker value
                    },
                },
                {
                    view: 'button', // Button component
                    value: _('Consultar'), // Localized label for the button
                    hotkey: 'enter', // Hotkey for the button
                    type: 'form', // Button type
                    autowidth: true, // Automatically adjust width
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country select value
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        this.app.callEvent('sessionReport:filter', [filterdata]); // Trigger filter event
                    },
                },
            ],
        };

        /**
         * Returns the configuration object for the main form.
         * @returns {Object} The configuration object for the main form.
         */
        return {
            view: 'form', // Form component
            id: 'myForm', // Unique identifier for the form
            rows: [upper_section, buttons], // Rows in the form
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for the form
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav2').hide(); // Hide the element with ID 'grav2' if the screen width is less than 500
            }
        });
    }
}
// FILE DOCUMENTED
